module.exports = "export default __webpack_public_path__ + &quot;f29268ecc51efa662706ade6f1195bc1.svg&quot;;"